import { render, staticRenderFns } from "./BookPod.vue?vue&type=template&id=b590f5a0&scoped=true&"
import script from "./BookPod.vue?vue&type=script&lang=js&"
export * from "./BookPod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b590f5a0",
  null
  
)

export default component.exports